import { Button, Flex, Text } from '@applyboard/crystal-ui';
import { Intake } from '~/data';
import { useApplication } from '~/context';

type SelectProgramButtonProps = {
  intake: Intake;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
  isDesktop?: boolean;
};

export function SelectProgramButton(props: Readonly<SelectProgramButtonProps>) {
  const { application } = useApplication();
  if (props.intake.status === 'OPEN') {
    if (application && application.programIntake.programIntakeId === props.intake.id) {
      return (
        <Flex pb={5} justify="center">
          <Text variant="labelL" contrast="low">
            Currently Selected
          </Text>
        </Flex>
      );
    }

    return (
      <Button
        intent="secondary"
        emphasis="outlined"
        width={props.isDesktop ? 'hug' : 'fill'}
        onClick={props.onClick}
        disabled={props.disabled}
        loading={props.loading}
      >
        Select
      </Button>
    );
  }

  return (
    <Flex pb={{ xs: 5, md: 0 }} justify={{ xs: 'center', md: 'start' }}>
      <Text variant="labelL" contrast="low">
        Not Available
      </Text>
    </Flex>
  );
}
